Ext.define('SA.VectorMapBusinessPointsGeoJsonSourceData', {
    singleton: true,

    get({businessSearch, extent, isLocationMaskEnabled, locations}, {enableServerSideClustering}) {
        if (!businessSearch) {
            return SA.GeoJson.createEmptyFeatureCollection();
        }

        var {country} = SA.data.BusinessSearches.get(businessSearch),
            location = SA.data.LocationsCache.normalizeLocation(locations.selected),
            locationSeries = [
                'and',
                SA.data.BusinessSearches.toQuery(businessSearch),
                ['>=', 'x', extent.getWest()],
                ['<=', 'x', extent.getEast()],
                ['>=', 'y', extent.getSouth()],
                ['<=', 'y', extent.getNorth()]
            ];

        if (isLocationMaskEnabled && location) {
            if (location.radius) {
                locationSeries.push(['radius', 'duns', location.radius, ...location.locationSeries]);
            }
            else {
                locationSeries.push(['within', ...location.locationSeries]);
            }
        }

        return SA.VectorMapGeoJsonSourceDataUrls.forPoints(SA.data.BusinessSearches.mapQueryFields(country, {cluster: enableServerSideClustering, locationSeries}));
    }
});